/* eslint-disable react/prop-types */ // TODO: add props
import createReactClass from 'create-react-class';
import _ from 'lodash';

export const ExamStartButton = createReactClass({
  displayName: 'ExamStartButton',

  handleClick: _.debounce(
    function (e) {
      e.preventDefault();

      const url = `/api/v1/exams/${this.props.examId}/start/`;
      const data = {};
      $.ajax({
        url,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
        data: JSON.stringify(data),
        success: function () {
          this.props.onExamStart();
        }.bind(this),
        error(xhr, status, err) {
          // var message = xhr.responseJSON.message;
          // var id = xhr.responseJSON.id;
          // TODO: Do something with the response -
          // Either go to the open exam sitting, or redirect somewhere.
          // Maybe show a message?
          // eslint-disable-next-line no-console
          console.error(url, status, err.toString());
        },
      });
    },
    1000,
    { leading: true, trailing: false }
  ),

  render() {
    const classes = `button ${this.props.className}`;

    return (
      <a
        href="#"
        className={classes}
        onClick={this.handleClick}
        data-exam-start-button={this.props.examId}
      >
        {this.props.children || 'Start Exam'}
      </a>
    );
  },
});
